import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { Injectable, OnDestroy, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class BreakpointService implements OnDestroy {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly breakpointObserver = inject(BreakpointObserver);
  private readonly destroy$ = new Subject<void>();
  private initialized = false;
  readonly isMobile$ = new BehaviorSubject<boolean>(false);

  ensureInitialized(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.initBrowserObserver();
    } else {
      this.isMobile$.next(false);
    }
  }

  private initBrowserObserver(): void {
    if (this.initialized) {
      return;
    }

    this.breakpointObserver
      .observe([Breakpoints.Handset, Breakpoints.Tablet])
      .pipe(takeUntil(this.destroy$))
      .subscribe((result: BreakpointState) => {
        this.isMobile$.next(result.matches);
      });

    this.initialized = true;
  }

  get isDesktop(): boolean {
    return !this.isMobile$.value;
  }

  get isMobile(): boolean {
    return this.isMobile$.value;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
